import { getOnlineBookAvailability } from '@services/firebase/learning'

const ONLINE_BOOK_AVAILABILITY_STALE_TIME_MS = 5 * 60 * 1000
const ONLINE_BOOK_AVAILABILITY_GC_TIME_MS = 10 * 60 * 1000

export function getOnlineBookAvailabilityQueryKey(bookId: string) {
  return ['learning', 'online-book-availability', bookId || 'unknown-book'] as const
}

export function getOnlineBookAvailabilityQueryOptions(bookId: string) {
  return {
    gcTime: ONLINE_BOOK_AVAILABILITY_GC_TIME_MS,
    queryFn: () => getOnlineBookAvailability(bookId),
    queryKey: getOnlineBookAvailabilityQueryKey(bookId),
    staleTime: ONLINE_BOOK_AVAILABILITY_STALE_TIME_MS,
  }
}
